export default __webpack_public_path__ + "static/media/MUR DE- SOUTENEMENT.e340e58e.svg";